import * as types from '../mutation-types'
import DriveApi from '../../api/drive'

const getDefaultState = () => {
  return {
    selectedNode: null,
    uploadFiles: [],
    treeData: {}
  }
}

let state = getDefaultState()

const getters = {
  getTree (state) {
    return state.treeData
  },
  getMatterId (state) {
    if (state.selectedNode) {
      let matterIdNode = state.selectedNode
      do {
        if (matterIdNode.data.matterId) {
          return matterIdNode.data.matterId
        }
        matterIdNode = matterIdNode.parent
      } while (matterIdNode)
      return null
    }
    return null
  }
}
let treeId = 0

const actions = {
  getTree: context => {
    // appel api
    DriveApi.getTree()
      .then(response => {
        let treeDataFromApi = response.data

        // transform
        let definitiveTree = []
        treeDataFromApi.forEach(el => {
          definitiveTree.push(actions.formatTreeElement(el))
        })
        // mutateur pr modifier state
        context.commit(types.DRIVE.SET, definitiveTree)
      })
  },
  setTree: (context, newTree) => {
    context.commit(types.DRIVE.SET, newTree)
  },
  addFile: (context, { newFile, TreePosition }) => {
    context.commit(types.DRIVE.ADD_FILE, { newFile: newFile, TreePosition: TreePosition })
  },
  deleteFile: (context, { file }) => {
    DriveApi.delete(file)
      .then(response => {
        context.commit(types.DRIVE.DELETE_FILE, { file: file })
      })
  },
  formatTreeElement: el => {
    let currentFolderChildren = []
    let currentFilesChildren = []
    let nbElement = 0
    if (el.children) {
      el.children.forEach(subEl => {
        nbElement++
        if (subEl.type === 'folder') {
          currentFolderChildren.push(actions.formatTreeElement(subEl))
        } else {
          currentFilesChildren.push(actions.formatTreeElement(subEl))
        }
      })
    }

    return {
      text: el.name,
      children: currentFolderChildren,
      state: {
        disabled: el.type !== 'folder',
        visible: el.type === 'folder'
      },
      data: {
        id: treeId++,
        matterId: el.id,
        nbElement: nbElement,
        fileSize: el.size,
        type: el.type,
        fileDate: el.updated_at,
        files: currentFilesChildren,
        permissions: el.permissions,
        path: el.path,
        isSharepoint: el.is_sharepoint,
        url: el.url,
        downloadUrl: el.downloadUrl // only Sharepoint
      }
    }
  },
  setSelectedNode: (context, { selectedNode }) => {
    context.commit(types.DRIVE.SET_SELECTED_NODE, selectedNode)
  },
  setUploadFiles: (context, { uploadFiles }) => {
    context.commit(types.DRIVE.SET_UPLOAD_FILES, uploadFiles)
  },
  reset: context => {
    context.commit(types.DRIVE.RESET)
  }
}

const mutations = {
  [types.DRIVE.SET] (state, treeData) {
    state.treeData = treeData
  },
  [types.DRIVE.ADD_FILE] (state, { newFile, TreePosition }) {
    const addFileToFolder = (folders) => {
      folders.forEach(el => {
        if (el.data.id !== TreePosition.data.id) {
          addFileToFolder(el.children)
          return
        }

        el.data.files.push(newFile)
      })
    }

    if (state.selectedNode.id === TreePosition.id) {
      state.selectedNode.data.files.push(newFile)
    }

    addFileToFolder(state.treeData)
  },
  [types.DRIVE.SET_SELECTED_NODE] (state, selectedNode) {
    state.selectedNode = selectedNode
  },
  [types.DRIVE.SET_UPLOAD_FILES] (state, uploadFiles) {
    state.uploadFiles = uploadFiles
  },
  [types.DRIVE.DELETE_FILE] (state, { file }) {
    const deleteFileFromFolder = (folder) => {
      folder.data.files = folder.data.files.filter(el => el.data.id !== file.data.id)
      folder.children.forEach(el => deleteFileFromFolder(el))
    }

    state.treeData.forEach(el => deleteFileFromFolder(el))
    deleteFileFromFolder(state.selectedNode)
  },
  [types.DRIVE.RESET] (state) {
    Object.assign(state, getDefaultState())
  }
}

// noinspection JSUnusedGlobalSymbols
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
